import Image from '@/components/UI/Image';
import EFDeltaProIcon1 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon1';
import EFDeltaProIcon10 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon10';
import EFDeltaProIcon2 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon2';
import EFDeltaProIcon3 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon3';
import EFDeltaProIcon4 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon4';
import EFDeltaProIcon5 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon5';
import EFDeltaProIcon6 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon6';
import EFDeltaProIcon7 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon7';
import EFDeltaProIcon8 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon8';
import EFDeltaProIcon9 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon9';
import { intlNumber } from '@/utils';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { useImperativeHandle } from 'react';
import css from './index.module.scss';
export default function TabInfo({ cRef }: any) {
    const { useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_new');
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'jp', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const { EFPic } = createEFPic(`/media/deltapro/h5/${imgSpec}/`);
    const lowerHrs = typeof t('Hrs') === 'string' ? t('Hrs').toLowerCase() : t('Hrs')?.props?.lang?.toLowerCase();
    type tab = {
        key: number;
        name: string;
        desc: string;
        icons: {
            id: number;
            title: string;
            hour: string;
            unit: string;
            icon: any;
        }[];
    };
    console.log('ttiem', t('Times'));

    const tabs: tab[] = [
        {
            key: 1,
            name: t('small_kWh'),
            desc: t('small_kWh_desc'),
            icons: [
                {
                    id: 0,
                    title: t('Phone'),
                    hour: '313',
                    unit: t('Times'),
                    icon: <EFDeltaProIcon1 />,
                },
                {
                    id: 1,
                    title: t('Laptop'),
                    hour: '57',
                    unit: t('Times'),
                    icon: <EFDeltaProIcon2 />,
                },
                {
                    id: 2,
                    title: t('Light'),
                    hour: '4',
                    unit: t('Day'),
                    icon: <EFDeltaProIcon3 />,
                },
                {
                    id: 3,
                    title: t('Refrigerator'),
                    hour: '1-2',
                    unit: t('Day'),
                    icon: <EFDeltaProIcon4 />,
                },
                {
                    id: 4,
                    title: t('Electric Drill'),
                    hour: '3',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon5 />,
                },
                {
                    id: 5,
                    title: t('Microwave'),
                    hour: intlNumber(locale, 2.5),
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon6 />,
                },
                {
                    id: 6,
                    title: t('Electric Kettle'),
                    hour: intlNumber(locale, 2.2),
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon7 />,
                },
                {
                    id: 7,
                    title: t('Electric Oven'),
                    hour: '2',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon8 />,
                },
                {
                    id: 8,
                    title: t('Air Conditioner'),
                    hour: `${intlNumber(locale, 1.8)}-${intlNumber(locale, 3.6)}`,
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon9 />,
                },
                {
                    id: 9,
                    title: t('Electric Heater'),
                    hour: intlNumber(locale, 1.5),
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon10 />,
                },
            ],
        },
        {
            key: 2,
            name: t('middle_kWh'),
            desc: t('middle_kWh_desc'),
            icons: [
                {
                    id: 0,
                    title: t('Phone'),
                    hour: '1095',
                    unit: t('Times'),
                    icon: <EFDeltaProIcon1 />,
                },
                {
                    id: 1,
                    title: t('Laptop'),
                    hour: '200',
                    unit: t('Times'),
                    icon: <EFDeltaProIcon2 />,
                },
                {
                    id: 2,
                    title: t('Light'),
                    hour: '16',
                    unit: t('Day'),
                    icon: <EFDeltaProIcon3 />,
                },
                {
                    id: 3,
                    title: t('Refrigerator'),
                    hour: `${intlNumber(locale, 3.5)}-7`,
                    unit: t('Day'),
                    icon: <EFDeltaProIcon4 />,
                },
                {
                    id: 4,
                    title: t('Electric Drill'),
                    hour: '10',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon5 />,
                },
                {
                    id: 5,
                    title: t('Microwave'),
                    hour: intlNumber(locale, 8.8),
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon6 />,
                },
                {
                    id: 6,
                    title: t('Electric Kettle'),
                    hour: intlNumber(locale, 7.7),
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon7 />,
                },
                {
                    id: 7,
                    title: t('Electric Oven'),
                    hour: '7',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon8 />,
                },
                {
                    id: 8,
                    title: t('Air Conditioner'),
                    hour: `${intlNumber(locale, 6.3)}-${intlNumber(locale, 12.6)}`,
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon9 />,
                },
                {
                    id: 9,
                    title: t('Electric Heater'),
                    hour: intlNumber(locale, 5.2),
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon10 />,
                },
            ],
        },
        {
            key: 3,
            name: t('large_kWh'),
            desc: t('large_kWh_desc'),
            icons: [
                {
                    id: 0,
                    title: t('Phone'),
                    hour: '2159',
                    unit: t('Times'),
                    icon: <EFDeltaProIcon1 />,
                },
                {
                    id: 1,
                    title: t('Laptop'),
                    hour: '393',
                    unit: t('Times'),
                    icon: <EFDeltaProIcon2 />,
                },
                {
                    id: 2,
                    title: t('Light'),
                    hour: '31',
                    unit: t('Day'),
                    icon: <EFDeltaProIcon3 />,
                },
                {
                    id: 3,
                    title: t('Refrigerator'),
                    hour: '7-14',
                    unit: t('Day'),
                    icon: <EFDeltaProIcon4 />,
                },
                {
                    id: 4,
                    title: t('Electric Drill'),
                    hour: '20',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon5 />,
                },
                {
                    id: 5,
                    title: t('Microwave'),
                    hour: '17',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon6 />,
                },
                {
                    id: 6,
                    title: t('Electric Kettle'),
                    hour: '15',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon7 />,
                },
                {
                    id: 7,
                    title: t('Electric Oven'),
                    hour: '13',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon8 />,
                },
                {
                    id: 8,
                    title: t('Air Conditioner'),
                    hour: '12-24',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon9 />,
                },
                {
                    id: 9,
                    title: t('Electric Heater'),
                    hour: '10',
                    unit: locale === 'de' ? t('Hrs') : lowerHrs,
                    icon: <EFDeltaProIcon10 />,
                },
            ],
        },
    ];

    const [tabIndex, setTabIndex] = useState(1);

    const changeTabIndex = (e: any) => {
        const index = e.target.dataset.index;
        setTabIndex(index);
        e.preventDefault();
    };

    const [isExpanIcon, setIsExpanIcon] = useState(false);
    const changeExpanIconPanel = () => {
        setIsExpanIcon(!isExpanIcon);
    };

    // 父组件调用方法
    useImperativeHandle(cRef, () => ({
        changeExpanIconFlag: (isExpanIcon: boolean) => setIsExpanIcon(isExpanIcon),
    }));
    return (
        <>
            <div className={css.tab_info}>
                <div className="img-container">
                    <div className="tab_info_img">
                        <div className={`deltaproall ${Number(tabIndex) === 1 ? 'show' : 'hide'}`}>
                            {locale === 'ph' ? (
                                <img src="https://websiteoss.ecoflow.com/upload/image/1751092727213/1-h5.jpg" alt={t('small_kWh')} className="fullImgs" />
                            ) : (
                                <EFPic name={[`1.webp`, `1.png`]} alt={t('small_kWh')} className="fullImgs" />
                            )}
                        </div>
                    </div>
                    <div className="tab_info_img">
                        <div className={`deltaproall ${Number(tabIndex) === 2 ? 'show' : 'hide'}`}>
                            {locale === 'ph' ? (
                                <img src="https://websiteoss.ecoflow.com/upload/image/1751092727432/2-h5.jpg" alt={t('middle_kWh')} className="fullImgs" />
                            ) : (
                                <EFPic name={[`2.webp`, `2.png`]} alt={t('middle_kWh')} className="fullImgs" />
                            )}
                        </div>
                    </div>
                    <div className="tab_info_img">
                        <div className={`deltaproall ${Number(tabIndex) === 3 ? 'show' : 'hide'}`}>
                            {locale === 'ph' ? (
                                <img src="https://websiteoss.ecoflow.com/upload/image/1751092727769/3-h5.jpg" alt={t('large_kWh')} className="fullImgs" />
                            ) : (
                                <EFPic name={[`3.webp`, `3.png`]} alt={t('large_kWh')} className="fullImgs" />
                            )}
                        </div>
                    </div>
                </div>
                <div className="tabsPanel">
                    <div className="tabs">
                        {tabs.map((tab: tab) => (
                            <div key={tab.key} className={`tab font-family-bold ${tab.key === Number(tabIndex) ? 'select' : ''}`}>
                                <a href="#" data-index={tab.key} onClick={changeTabIndex} aria-label={tab.name}>
                                    {tab.name}
                                </a>
                                <div
                                    className="activeLine"
                                    style={{
                                        display: tab.key === Number(tabIndex) ? 'inline-block' : 'none',
                                    }}
                                ></div>
                            </div>
                        ))}
                    </div>
                    <div className="content">
                        <p className="desc font-family-bold">{tabs.find((tab) => tab.key === Number(tabIndex))?.desc}</p>
                        <div onClick={changeExpanIconPanel} className="action font-family-semibold">
                            {t('WCIP_h5')}
                            <i style={{ lineHeight: 0 }}>
                                <Image
                                    src="/media/deltapro/h5/arrow-blue.png"
                                    className={`arraw ${isExpanIcon ? 'reverse' : ''}`}
                                    width={21}
                                    height={21}
                                    alt={t('arrow button')}
                                    noUseSrcset={true}
                                />
                            </i>
                        </div>
                        <div className={`icons ${isExpanIcon ? '' : 'hide'}`}>
                            <div className="icon-content">
                                {tabs
                                    .find((tab) => tab.key === Number(tabIndex))
                                    ?.icons.map((icon, index) => (
                                        <div key={icon.id} className={`icon_item ${index < 5 ? 'line1' : 'line2'}`}>
                                            <div className="icon_img">{icon.icon}</div>
                                            <p className="t">{icon.title}</p>
                                            <p className="h">
                                                <strong className="font-family-bold">{icon.hour}</strong>
                                                <span className="font-family-semibold unit">{icon.unit}</span>
                                            </p>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <p className={`footnote ${isExpanIcon ? '' : 'hide'}`}>{t('capacity_notice')}</p>
                </div>
            </div>
        </>
    );
}
